import React from "react";

interface BaseButtonProps {
  text: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const BaseButton: React.FC<BaseButtonProps> = ({ text, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`
        bg-navyBlue-primary text-white
        px-3 py-1 rounded-md
        text-xs font-semibold
        transition-transform duration-150
        hover:scale-105 active:scale-95
        whitespace-nowrap
        max-w-full
      `}
      style={{
        fontSize: text.length > 8 ? "0.65rem" : "0.75rem", // shrink a bit if longer text
      }}
    >
      {text}
    </button>
  );
};

export default BaseButton;
